'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureApi = exports.reducerMethodsFor = exports.createReducer = exports.createActionObject = exports.serializeFields = exports.serializeForMutation = exports.serializeEnum = exports.wrapAction = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _messages = require('./messages');

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DATA_FETCHING_FAILURE = _messages2.default.DATA_FETCHING_FAILURE;
var CONNECTIVITY_ERROR = _messages2.default.CONNECTIVITY_ERROR;

var jsStringEscape = function jsStringEscape(string) {
  return ('' + string).replace(/["\\\n\r\u2028\u2029]/g, function (character) {
    switch (character) {
      case '"':
      case '\\':
        return '\\' + character;
      // Four possible LineTerminator characters need to be escaped:
      case '\n':
        return '\\n';
      case '\r':
        return '\\r';
      case '\u2028':
        return '\\u2028';
      case '\u2029':
        return '\\u2029';
    }
  });
};

var wrapAction = exports.wrapAction = function wrapAction(actions, query_name, action_name, promise) {
  var context = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var start = actions[action_name + 'Start'];
  var success = actions[action_name + 'Success'];
  var failure = actions[action_name + 'Failure'];

  start(context);

  return promise.then(function (res) {
    var _ref = res || {},
        data = _ref.data,
        errors = _ref.errors,
        cid = _ref.cid;

    context.cid = cid;

    if (data && !errors) {
      var result = _fp2.default.property(query_name)(data);

      // success should fire even if result is null
      return success(result, context);
    }

    if (errors && errors.length) {
      return failure(errors, context);
    }

    return failure([{ message: DATA_FETCHING_FAILURE }], context);
  }).catch(function (errors) {
    if (errors.toString().indexOf('Network request') !== -1) {
      failure([{ message: CONNECTIVITY_ERROR }], context);
      return;
    }
    if (errors) return failure(errors);
    failure([{ message: DATA_FETCHING_FAILURE }], context);
  });
};

var serializeEnum = exports.serializeEnum = function serializeEnum(string) {
  var s = new String(string.toUpperCase());
  s.__isGraphQLEnumValue = true;
  return s;
};

var formatGraphQLString = function formatGraphQLString(string) {
  if (_fp2.default.isObject(string) && string.__isGraphQLEnumValue) {
    return string.toString(); // no quotes
  }

  if (!string) return '""';

  var escaped = jsStringEscape(string);
  return '"' + escaped + '"';
};

var serializeObject = function serializeObject(value) {
  if (_fp2.default.isDate(value)) {
    // In order to not alter the original passed date,
    // we need to subtract the timezone offset.
    var diff = new Date().getTimezoneOffset() * 60000;
    return '"' + new Date(value.getTime() - diff).toISOString() + '"';
  }
  if (_fp2.default.isString(value)) return formatGraphQLString(value);
  if (_fp2.default.isArray(value)) return '[ ' + serializeForMutation(value) + ' ]';
  if (_fp2.default.isObject(value)) return '{ ' + serializeForMutation(value) + ' }';
  if (_fp2.default.isUndefined(value) || _fp2.default.isNull(value)) return "null";

  return value;
};

var serializeForMutation = exports.serializeForMutation = function serializeForMutation(data) {
  var isArray = _fp2.default.isArray(data);
  var map = isArray ? _fp2.default.map : _fp2.default.mapValues;

  var serialized = map(serializeObject, data);

  return Object.keys(serialized).reduce(function (acc, key) {
    var item = serialized[key];
    var obj = isArray ? item : [key, item].join(': ');
    return acc.concat(obj);
  }, []).join(' ');
};

var serializeFields = exports.serializeFields = function serializeFields(fields, data) {
  return serializeForMutation(_fp2.default.pick(fields, data));
};

var createActionObject = exports.createActionObject = function createActionObject(action_name, start, success, failure) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, action_name + 'Start', function undefined(context) {
    return {
      type: start,
      context: context
    };
  }), _defineProperty(_ref2, action_name + 'Success', function undefined(data, context) {
    return {
      type: success,
      data: data,
      context: context
    };
  }), _defineProperty(_ref2, action_name + 'Failure', function undefined(errors, context) {
    return {
      type: failure,
      errors: errors,
      context: context
    };
  }), _ref2;
};

var createReducer = exports.createReducer = function createReducer(initialState, reducer) {

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var method = action.type;
    if (reducer[method]) {
      return reducer[method](state, action);
    }

    return state;
  };
};

var reducerMethodsFor = exports.reducerMethodsFor = function reducerMethodsFor(property, start, failure) {
  var _ref3;

  return _ref3 = {}, _defineProperty(_ref3, start, function (state, action) {
    var _extends2;

    return _extends({}, state, (_extends2 = {}, _defineProperty(_extends2, property, true), _defineProperty(_extends2, 'errors', []), _extends2));
  }), _defineProperty(_ref3, failure, function (state, action) {
    var _extends3;

    return _extends({}, state, (_extends3 = {}, _defineProperty(_extends3, property, false), _defineProperty(_extends3, 'errors', action.errors), _extends3));
  }), _ref3;
};

var configureApi = exports.configureApi = _fp2.default.curry(function (setApiHeaders, accessToken) {
  var headers = {};
  if (accessToken) {
    headers.Authorization = 'Bearer ' + accessToken;
  };
  setApiHeaders(headers);
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/util.js
// module id = 25
// module chunks = 0